export const useTeamContext = () => {
  const teamName = useState<string | null>("teamName", () => null);

  const setTeamName = (name: string | null) => {
    teamName.value = name;
  };

  return {
    teamName,
    setTeamName,
  };
};
